import { MenuProps } from 'antd';
import React from 'react';
import {
  getAssetTypes,
  getAssetsKeyedByTypes,
  getSelectedAssetType,
} from '../../../selectors';
import { DropdownFilter } from '../../atoms';
import { analytics } from '../../../services';
import { getContextStores } from '../../../context';
import { setAssetDetailsAssetId, setSelectedAssetTypeId } from '../../../actions';

export interface Props {
  size?: 'small' | 'default';
}

const Filters = ({ size = 'default' }: Props) => {
  /* Context */
  const contextStores = getContextStores();
  const { featureState, assetManagerDispatch, layoutDispatch } = contextStores;
  const { assetManagerId } = featureState;

  /* Selectors */
  const assetTypes = getAssetTypes(contextStores);
  const assetsKeyedByTypes = getAssetsKeyedByTypes(contextStores);

  const items = assetTypes.map(({
    label_pluralized_long,
    label_pluralized,
    label,
    id,
  }) => {
    const title = label_pluralized_long || label_pluralized || label;
    const labelDisplay = `${title} (${assetsKeyedByTypes.get(id)?.length || 0})`;
    return {
      label: labelDisplay,
      key: id,
    };
  });

  const onClick: MenuProps['onClick'] = ({ key }) => {
    analytics.trackEvent('Asset Type Dropdown Changed', { asset_type: key });
    setSelectedAssetTypeId(key, assetManagerId, assetManagerDispatch);
    setAssetDetailsAssetId(null, true, layoutDispatch);
  };

  // Auto select the first type if nothing is selected
  const currentType = getSelectedAssetType(contextStores);
  const currentTypeLabel = (
    `${currentType?.label_pluralized_long || currentType?.label_pluralized || currentType?.label}`
  );

  return (
    <DropdownFilter
      label={currentTypeLabel}
      menu={{ onClick, items }}
      size={size}
    />
  );
};

export default Filters;
